<template>
	<div>
		<deal-pack-view
			:deal-pack="dealPack"
		/>
	</div>
</template>

<route>
{
	"meta": {
		"isAdminOnly": true
	}
}
</route>

<script>

	import DealPackView from '@/components/dealPacks/DealPackView';
	import routeParams  from '@/mixins/routeParams';
	import api          from '@/services/api';

	export default {
		metaInfo () {
			if (!this.getDealPackTitle) {
				return false;
			}
			return {
				title: this.getDealPackTitle
			};
		},

		layout: 'v2default',

		components: {
			DealPackView
		},
		mixins: [routeParams],
		data: () => ({
			dealPack: {}
		}),
		computed: {
			getDealPackTitle () {
				if (!this.dealPack) {
					return false;
				}
				return this.dealPack.title;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/admin',
						text: 'Admin'
					},
					{
						path: this.getDealPacksRoute,
						text: 'Deal Packs'
					},
					{
						path: this.getDealPackRoute,
						text: this.getDealPackTitle
					}
				];
			}
		},
		created () {
			this.setDealPack();
		},
		methods: {
			async setDealPack () {
				const dealPack = await api.admin.getDealPackById({
					dealPackId: this.getDealPackId
				});
				if (!dealPack) {
					this.$store.commit('ui/showError');
					return false;
				}

				const teacherProfile = await api.teacherProfiles.getTeacherProfileById({
					profileId: dealPack.teacherProfileId
				});

				if (!teacherProfile) {
					this.$store.commit('ui/showError');
					return false;
				}

				dealPack.teacherProfile = teacherProfile;

				this.dealPack = dealPack;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};

</script>
